<template>
  <div class="approval-levels">
    <div class="d-flex justify-space-between">
      <h2 class="pb-1">Approvers</h2>
      <Permissioned section="bookings" :id="currentBookingId">
        <PrimaryButton
          permission="edit.approval-chains"
          @click.native="$emit('edit')"
          light
          dense
          shrink
          class="edit-button"
        >
          Edit
          <template v-slot:append:icon><v-icon>mdi-pencil</v-icon></template>
        </PrimaryButton>
      </Permissioned>
    </div>
    <div
      v-if="showWarning"
      class="d-flex justify-center align-center warning-background py-6 my-2"
    >
      <v-icon class="mr-2" color="error" x-large>mdi-alert</v-icon>
      <strong>There are no approvers for this role</strong>
    </div>
    <div v-else>
      <div
        v-for="(approvalLevel, level) in approvalGroups"
        :key="level"
        class="mt-3 mb-4"
      >
        <div class="mb-1">
          <v-icon v-if="isLevelApproved(approvalLevel)" class="approved">
            mdi-check-circle
          </v-icon>
          <v-icon v-else class="gray">
            mdi-circle
          </v-icon>
          <span :class="{ 'font-weight-bold': isLevelApproved }">
            {{ `Level ${level}` }}
          </span>
        </div>
        <div class="d-flex">
          <div v-for="(approver, index) in approvalLevel" :key="index">
            <v-chip class="selected-worker-chip mr-2">
              <v-icon class="mr-1">mdi-account</v-icon>
              {{ approver.user | fullName }}
              <v-icon v-if="approver.approvalDate" class="approved">
                mdi-checkbox-marked
              </v-icon>
              <v-icon v-else class="gray">
                mdi-help-box
              </v-icon>
            </v-chip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { groupByPropertyName } from "@/utils/bookings";
import Permissioned from "@/components/common/Permissioned";
import PrimaryButton from "@/components/common/Button/PrimaryButton";

export default {
  name: "ApprovalProgress",
  components: { Permissioned, PrimaryButton },
  inject: ["currentBookingId"],
  props: {
    approvers: Array
  },
  computed: {
    approvalGroups() {
      return groupByPropertyName(this.approvers, "levelNbr");
    },
    showWarning() {
      return !Object.keys(this.approvalGroups).length;
    }
  },
  methods: {
    isLevelApproved(approvals) {
      return approvals.every(approval => approval.approvalDate);
    }
  }
};
</script>

<style lang="scss">
.warning-background {
  background-color: #ea0b3f34;
}
</style>
